import React from 'react';

const PackageCard = ({ pkg }) => (
  <div
    className="rounded-lg shadow-lg h-full bg-white hover:cursor-pointer"
    onClick={() => window.open(`/package/${encodeURIComponent(pkg.title)}`, '_blank')}
  >
    <img
      className="h-[180px] w-full object-cover"
      src={pkg.image}
      alt={pkg.title}
    />
    <div className="p-4">
      <h2 className="text-xl font-semibold text-orange-600 mb-2">
        {pkg.title}
      </h2>
      <p className="text-sm text-gray-600 mb-2">
        {pkg.summary}
      </p>
      <p className="text-md font-medium text-green-600">
        {pkg.price.split('\n')
               .map(e =><p className='mb-1'>{e}</p>)}
      </p>
    </div>
  </div>
);

export default PackageCard;
